module.exports = __webpack_public_path__ + "static/media/desk-illu.664c44e2.svg";